import { useQuery } from "@tanstack/react-query";
import type { ConnectorPlatform } from "@veritrellis/shared/connectors";
import { apiFetch } from "../lib/api.js";

export type AccessManifestResponse = {
  manifest: {
    role: string;
    strict_production_separation: boolean;
    can: Record<string, boolean>;
  };
  /** Connector platforms the workspace is allowed to use (global toggle + org entitlement). */
  enabled_connector_platforms: ConnectorPlatform[];
  workspace: { strict_production_separation: boolean };
};

export type AccessManifestCan = keyof AccessManifestResponse["manifest"]["can"];

export const useAccessManifest = (workspaceId: string | null) => {
  return useQuery({
    queryKey: ["access", "manifest", workspaceId],
    enabled: workspaceId !== null,
    queryFn: async (): Promise<AccessManifestResponse> => {
      const res = await apiFetch(`/admin/workspaces/${workspaceId}/access/manifest`);
      if (!res.ok) {
        throw new Error(`manifest_${String(res.status)}`);
      }
      return (await res.json()) as AccessManifestResponse;
    }
  });
};
